var _defs, _style, _use, _use2, _use3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 300",
    width: 300,
    height: 300,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "image_icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 300,
    height: 300,
    id: "img1",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAASwAAAEsAQMAAABDsxw2AAAAAXNSR0IB2cksfwAAAANQTFRFAAAAp3o92gAAAAF0Uk5TAEDm2GYAAAAiSURBVHic7cExAQAAAMKg9U9tCj+gAAAAAAAAAAAAAAB4GS20AAFmdDNkAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    width: 128,
    height: 128,
    id: "img2",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAMAAAD04JH5AAAAAXNSR0IB2cksfwAAAGBQTFRFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA+k/ojQAAACB0Uk5TADB/v//vr28Q31Cfz7CAcGAgwC9fDz+PH09AkODw0KDRZ7c8AAADjklEQVR4nO2b63arIBCF8YL3GGNiNG1O8/5v2ZgoDIKXiIPrdDF/WrLU/QlbgQEJ4eG4no8fNAgdoogojA2odxGH0VA/MSj/QkjE20/NyrcRgEqIMvP6vp9F++oDgh3q/x1p5z8IdciR4wCr++XEiPmf5tLDgRFRTnvFuC0f2d0bkX8hsFoonqW+AjJT8m1kvAqcvv6N3X8bUd8KDmsB16Q+IW4nm5ND99/JLEDUyZak3MEBbfQuIF1jeKYBgh5gHwtwE1gAC2ABLIAFsAAWwAJYAAtgASyABfjTAGc38Dz3Uu0EcO0n4LRWIaAD1D6P7GweQEx+UpkAGWCYfKWNWQA5+ZsNfYAKoEo+pwYBgH7J10FCYwBcnzqwdDMEwBXfyWdWFh8FNIChPs8IikbEApD1eV7YD/ABFPqEOIygxgZQ6hNSsJ8vuAAj+qBj4EbEABjVJ4StCce9EREAJvTBIk2flt8eYEofGjFFApjWh4uDFxSAOX2u6PtnBIB5ffhObjYHWKIPjVhtDLBIn5ATNOKWAAv1CfliB4aLAZqbe7lupA/fybdlALf3G4ym0phylT404pJVsypg1x5voo/0weCgjwmARjg4U1fCh/pgcDALcB4cqphcfK7PF8tnAS7DuoKd+Xp9aMRJAOW+kuHYXhz/Lo1auKYaoBrZ0+UJ85t1+mBwMApwBvbzkgSUYmCEtfpg18oIALRf3v7wzcuUTS9W68PBgRIA2I8W75+gcUJtfeF6MgDvt8GlIXOqrQ9FJABg/wxs6zgBIzx7U019vn9hCFBB+wmPdgTeyzG/gZX63IgiALT/8KGHVtTW528DAeAKWvoon1MM5TX0leMBaP9EdZIz7B7W66sA6vkrn7Kt9GWACtp/tGeBez+19CWAFNxbMNWz5dvoSwAgvqfPLOgW+hMAxdypTjbZSpoA9GvByUk+S7kWINasWF0Ac7s61QCpwV2VKoAZ+6MD6BtLC2CR/REBdN8r2gBS728a4E+uG1oAC2ABLIAF+E8A7u+/wfwp2wZL1e78icc/9pHLRDoaI5pO9rD/Zz7sQyejVVDxD53IT/evtMsDU7+fi98JSLyMJOQRgi8EvBJB975EXSMIjcsyPffXVIwvJT0np56LG7UHE8XdXOTh7xRsLvgzfyxGPFirRLsQlNAYqiwocuSiNZP7/ClbRinPhQuD7aCQb+N0PJTo2j/lo4CJmF+9uV4Gmy72zAAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    width: 37,
    height: 37,
    id: "img3",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACUAAAAlCAMAAADyQNAxAAAAAXNSR0IB2cksfwAAAGBQTFRFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA+k/ojQAAACB0Uk5TAD8wj8//r18gb++/QN+fUBCAkHBgoE8PwB/Q4C/wsH90hneJAAABNUlEQVR4nI2U25aDIAxF0YoioIKtIx3H9v//slAhcnXNecK4SUISQChWVdWJLVB9a/ChtiMFpqfYF+MZphtwrDHxNyaMFp0CRjQ5SKv/D4SxPKm2CGEMQWfP2MqJ32fPN7XVI6dFCruRMDCywwKGRpxJoAdU71s3noV0Ixw2mK/FfYSQ9uY7c1uqpB2u0vMZkCUQHEuHlHb5k1JQxxrSWjNUB4kpe8AMhCqovyqmpftrKXlJrTE1XEXk0Orr7O921V1UQqC6XNWn/fWr11vRmRsWM68uMfoXQb3rtplDGMLmmU0dq++n6xGm3lisN2c9phCRHQzMRl29O/yy+2DcjD/2fo/MM+wwnP4liuW9Fq8i9PAPtOSZPYDC3EBb8t6RNKqMb5URD7hNll5DMS3KtFUpGcb6AMImFPP5IULkAAAAAElFTkSuQmCC"
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _use || (_use = /*#__PURE__*/React.createElement("use", {
    id: "Background",
    href: "#img1",
    x: 0,
    y: 0
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    id: "Layer 1",
    href: "#img2",
    x: 86,
    y: 86
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    id: "Layer 2",
    href: "#img3",
    x: 110,
    y: 104
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageIcon);
export default __webpack_public_path__ + "static/media/image_icon.c1060f3a0391258db89b0af53bd1abfe.svg";
export { ForwardRef as ReactComponent };